// src/utils/mockedData.js

export const mockedData = {
    visitorData: {
      unique: 1200,
      repeat: 800
    },
    trafficData: {
      referral: 500,
      organicSearch: 1000,
      paidSearch: 300,
      direct: 200
    },
    sessionData: {
      sessionDuration: 320 // in seconds
    },
    geographyData: {
      country: 'United States',
      region: 'California',
      city: 'Las Vegas'
    },
    bounceData: {
      bounce: 400,
      noBounce: 1600
    },
    totalVisitorsData: {
      totalVisitors: 2000,
      dailyVisitors: [
        { date: '2023-04-01', visitors: 120 },
        { date: '2023-04-02', visitors: 150 },
        { date: '2023-04-03', visitors: 180 },
        { date: '2023-04-04', visitors: 140 },
        { date: '2023-04-05', visitors: 200 },
        { date: '2023-04-06', visitors: 170 },
        { date: '2023-04-07', visitors: 190 }
      ]
    }
  };
  